<template>
  <div class="l-content wrapper">
    <div class="c-container">
      <div class="p-container">
        <div class="app-icon">
          <img src="@/assets/img/signup/iOS_icon.png" class="app-icon" alt="アプリアイコン">
        </div>
      </div>

      <div class="p-container u-mtxl title">
        <div>引き続きギグベースを利用するにはアプリが必要です</div>
      </div>

      <div class="p-container u-mtl content">
        <p>アプリをインストール後、ログインして<br />ギグベースを始めましょう。</p>
      </div>

      <div class="p-container u-mtxl store-links">
        <a href="https://apps.apple.com/jp/app/spotgig/id1466176511">
          <img src="@/assets/img/app/appstore.png">
        </a>

        <a href="https://play.google.com/store/apps/details?id=jp.co.axis_motion.spotgig">
          <img src="@/assets/img/app/googleplay.png">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionExpired',
  created() {
    this.$emit('page-navbar', false);
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
}

.title {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;

  text-align: center;
  letter-spacing: 0.03em;
}

.content {
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;

  text-align: center;
  letter-spacing: 0.03em;
}

.app-icon {
  display: block;
  max-width: 138px;
  margin: 0 auto;

  border: 1px solid #F4F4F4;
  box-shadow: 0px 14px 20px rgba(0, 0, 0, 0.08);
  border-radius: 19px;
}

.button-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0 40px 62px;
}
.button {
  display: block;

  text-align: center;
  text-decoration: none;

  background-color: #F94848;
  color: white;
  border-radius: 60px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  padding: 18px 0;
}

.store-links {
  img {
    max-width: 200px;
  }
  text-align: center;
}
</style>
